/* global Helpers */

import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const Chart = ({ chartData, containerId = null, containerStyle = {} }) => {
  const chartContainerRef = useRef()

  useEffect(() => {
    initChart()
  }, [chartData])

  const initChart = () => {
    Helpers.renderHighchart(chartContainerRef.current, chartData)
  }

  return (
    <div className="chart-container" id={containerId} ref={chartContainerRef} style={containerStyle}>
      <div className="graph">
        <i className="fas fa-sync-alt fa-spin" />
      </div>
    </div>
  )
}

Chart.propTypes = {
  containerId: PropTypes.string,
  containerStyle: PropTypes.object,
  chartData: PropTypes.object.isRequired
}

export default Chart
